<div class="version-details-container ml-72 mr-72 mt-34">
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

  <div *ngIf="!isLoadingheader" class="flex flex-row header-section p-24">
    <div class="pr-24">
      <mat-icon svgIcon="arrow_back" class="arrow mt-4 cursor-pointer icon-lg" [routerLink]="['/', tenant, RouterSegments.TENANT, tenantId, RouterSegments.SOLUTION, data?.solutionId, RouterSegments.VERSIONS]"></mat-icon>
    </div>
    <div class="flex flex-col">
      <div class="pb-12 mat-subtitle-1 mb-0 fw-600">
        {{data?.name}}
      </div>
      <mat-divider class="pb-12 neutral-2 header-divider"></mat-divider>
      <div class="flex justify-between items-center header-fields">
        <div>
          <div class="fw-600 pb-6 mat-subtitle-1 mb-0 fs-14">{{'SOLUTIONS.SOLUTION_NAME' | transloco | titlecase}}</div>
          <div class="overview-values">{{data?.name}}</div>
        </div>
        <div>
          <div class="fw-600 pb-6 mat-subtitle-1 mb-0 fs-14">{{'SOLUTIONS.VERSION' | transloco | titlecase}}</div>
          <div class="overview-values">{{data?.version ? data?.version : '-'}}</div>
        </div>
        <div>
          <div class="fw-600 pb-6 mat-subtitle-1 mb-0 fs-14">{{'SOLUTIONS.RELEASE_VERSION' | transloco | titlecase}}</div>
          <div class="overview-values">{{data?.releaseVersion ? data?.releaseVersion : '-'}}</div>
        </div>
        <div>
          <div class="fw-600 pb-6 mat-subtitle-1 mb-0 fs-14">{{'SOLUTIONS.CREATED_DATE' | transloco | titlecase}}</div>
          <div class="overview-values">{{dateTimeFormatService.getUtcFromat(data?.dateCreated)}}</div>
        </div>
        <div>
          <div class="fw-600 pb-6 mat-subtitle-1 mb-0 fs-14">{{'SOLUTIONS.UPDATED_DATE' | transloco | titlecase}}</div>
          <div class="overview-values">{{dateTimeFormatService.getUtcFromat(data?.dateUpdated)}}</div>
        </div>
        <div>
          <div class="fw-600 pb-6 mat-subtitle-1 mb-0 fs-14">{{'SOLUTIONS.STATUS' | transloco | titlecase}}</div>
          <div class="overview-values flex items-center">
            <span class="sucess-circle mr-6" *ngIf="data?.status === SolutionStatus.PUBLISHED">
              <mat-icon svgIcon="done" class="icon-sm p-2"></mat-icon>
            </span>
            {{data?.status ? (data?.status | titlecase) : '-'}}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="flex justify-between items-center">
    <div>
      <div class="fw-700">{{'SOLUTIONS.SOLUTION_NAME' | transloco}}</div>
      <div class="overview-values">{{data?.name}}</div>
    </div>
    <div>
      <div class="fw-700">{{'SOLUTIONS.VERSION' | transloco}}</div>
      <div class="overview-values">{{data?.version}}</div>
    </div>
    <div>
      <div class="fw-700">{{'SOLUTIONS.RELEASE_VERSION' | transloco}}</div>
      <div class="overview-values">{{data?.releaseVersion}}</div>
    </div>
    <div>
      <div class="fw-700">{{'SOLUTIONS.STATUS' | transloco}}</div>
      <div class="overview-values">{{data?.status}}</div>
    </div>
    <div>
      <div class="fw-700">{{'SOLUTIONS.CREATED_DATE' | transloco}}</div>
      <div class="overview-values">{{dateTimeFormatService.getUtcFromat(data?.dateCreated)}}</div>
    </div>
    <div>
      <div class="fw-700">{{'SOLUTIONS.UPDATED_DATE' | transloco}}</div>
      <div class="overview-values">{{dateTimeFormatService.getUtcFromat(data?.dateUpdated)}}</div>
    </div>
  </div> -->
  <div *ngIf="!isLoading" class="pt-32">
    <mat-tab-group [(selectedIndex)]="selectedTabIndex">
      <mat-tab label="{{'TENANT_DETAILS.DETAILS' | transloco }}">
        <mat-divider class="neutral-2 header-divider width"></mat-divider>
        <div class="flex flex-row items-center pt-24">
          <div class="metrics fw-700 pt-8 pb-8">
            {{'SOLUTIONS.ID' | transloco}}
          </div>
          <div>
            <span class="pr-24">:</span>{{data?.id ? data?.id : '-'}}
          </div>
        </div>
        <div class="flex flex-row items-center">
          <div class="metrics fw-700 pt-8 pb-8">
            {{'SOLUTIONS.SOLUTION_ID' | transloco}}
          </div>
          <div>
            <span class="pr-24">:</span>{{data?.solutionId ? data?.solutionId : '-'}}
          </div>
        </div>
        <div class="flex flex-row items-center">
          <div class="metrics fw-700 pt-8 pb-8">
            {{'SOLUTIONS.DESCRIPTION' | transloco}}
          </div>
          <div>
            <span class="pr-24">:</span>{{data?.description ? data?.description : '-'}}
          </div>
        </div>
        <!-- <div class="flex flex-row items-center">
          <div class="metrics fw-700 pt-8 pb-8">
            {{'SOLUTIONS.RELEASE_NOTES' | transloco}}
          </div>
          <div>
            <span class="pr-24">:</span>{{data?.releaseNotes ? data?.releaseNotes : '-'}}
          </div>
        </div> -->
        <div class="flex flex-row items-center">
          <div class="metrics fw-700 pt-8 pb-8">
            {{'SOLUTIONS.SANDBOX_TYPE' | transloco}}
          </div>
          <div>
            <span class="pr-24">:</span>{{data?.sandboxType ? data?.sandboxType : '-'}}
          </div>
        </div>
        <div class="flex flex-row items-center">
          <div class="metrics fw-700 pt-8 pb-8">
            {{'SOLUTIONS.INSTALLATION_SPECIFICATION' | transloco}}
          </div>
          <div *ngIf="!data?.installationSpecification">
            <span class="pr-24">:</span>{{'-'}}
          </div>
          <div>
            <span class="pr-24">:</span><a *ngIf="data?.installationSpecification" class="items-center fw-400 fs-14" href="javascript:void(0)" (click)="onClick(data?.installationSpecification)">{{'SOLUTIONS.VIEW' | transloco}}</a>
          </div>
        </div>
        <div class="flex flex-row items-center">
          <div class="metrics fw-700 pt-8 pb-8">
            {{'SOLUTIONS.SANDBOX_SPECIFICATION' | transloco}}
          </div>
          <div *ngIf="!data?.sandboxInstallationSpec">
            <span class="pr-24">:</span>{{'-'}}
          </div>
          <div *ngIf="data?.sandboxInstallationSpec">
            <span class="pr-24">:</span><a class="items-center fw-400 fs-14" href="javascript:void(0)" (click)="onClickSandbox(data?.sandboxInstallationSpec)">{{'SOLUTIONS.VIEW' | transloco}}</a>
          </div>
        </div>
        <div class="flex flex-row items-center">
          <div class="metrics fw-700 pt-8 pb-8">
            {{'SOLUTIONS.SPEC_VERSION' | transloco}}
          </div>
          <div>
            <span class="pr-24">:</span>{{data?.specVersion ? data?.specVersion : '-'}}
          </div>
        </div>
        <div class="flex flex-row items-center">
          <div class="metrics fw-700 pt-8 pb-8">
            {{'SOLUTIONS.ATF_VERSION' | transloco}}
          </div>
          <div>
            <span class="pr-24">:</span>{{data?.atf?.version ? data?.atf?.version : '-'}}
          </div>
        </div>
        <div class="flex flex-row items-center">
          <div class="metrics fw-700 pt-8 pb-8">
            {{'SOLUTIONS.CBASE_VERSION' | transloco}}
          </div>
          <div>
            <span class="pr-24">:</span>{{data?.cbase?.version ? data?.cbase?.version : '-'}}
          </div>
        </div>
        <div class="flex flex-row items-center">
          <div class="metrics fw-700 pt-8 pb-8">
            {{'SOLUTIONS.ISB_TYPES' | transloco}}
          </div>
          <div>
            <span class="pr-24">:</span>{{data?.supportedISBTypes?.length ? data.supportedISBTypes.join(', ') : '-' }}
          </div>
        </div>
      </mat-tab>
      <mat-tab label="{{'SOLUTIONS.CAPABILITIES' | transloco }}">
        <mat-divider class="neutral-2 header-divider width"></mat-divider>
        <div class="flex flex-row cards-section pt-32">
          <div class="flex flex-row">
            <div class="capability-card mr-24 ">
            <h2 class="mat-subtitle-2 fw-700 mt-0 mb-0 p-16">{{'SOLUTIONS.INCLUDED' | transloco}}</h2>
            <div *ngIf="filteredMandatoryCapabilities.length > 0">
              <div *ngFor="let mandatory of filteredMandatoryCapabilities; let i = index" class="flex flex-col mat-body-2 fs-16 mt-12 rows pl-16">
                <button class="flex items-center btn-link fs-16 fw-500" (click)="openCreateConfigurationInstanceForm(mandatory?.name, mandatory?.version, 'Included')">
                  <span>{{ i + 1 }}. <span class="capabilityname">{{ mandatory?.displayName ? mandatory?.displayName : mandatory?.name }}</span></span>
                </button>
                <div class="rvtTag mat-headline-2 fw-700 mt-8 mb-12 fs-10">
                  <span class="rvtTags">{{ 'SOLUTIONS.RVT_TAGS' | transloco }}</span>: {{ mandatory.rvtTags }}
                </div>
                <div *ngIf="mandatory.componentType" class="componentTag mat-headline-2 fw-700 h-40 mb-0 fs-10">
                  <span class="componentType fw-500 fs-10">{{ 'INSTANCE_DETAILS.COMPONENT' | transloco | uppercase }}</span>:
                  <span class="flex flex-row items-center badge fs-10 fw-700 pr-8 pl-8 ml-80">{{ mandatory.componentType }}</span>
                </div>
              </div>
            </div>
              <div *ngIf="filteredMandatoryCapabilities.length === 0" class="flex items-center mat-body-2 fs-14 fw-400 rows pl-16">
                {{'SOLUTIONS.No_INCLUDED_CAPABILITIES' | transloco}}
              </div>
            </div>
            <div class="capability-card">
                <h2 class="mat-subtitle-2 fw-700 mt-0 mb-0 p-16">{{'SOLUTIONS.OPTIONAL' | transloco}}</h2>
                <div *ngIf="filteredOptionalCapabilities.length > 0">
                  <div *ngFor="let optional of filteredOptionalCapabilities; let i = index" class="flex flex-col mat-body-2 fs-16 rows mt-12 pl-16">
                    <button class="flex items-center btn-link fs-16 fw-500" (click)="openCreateConfigurationInstanceForm(optional?.name, optional?.version, 'Optional')">
                      <span>{{ i + 1 }}. <span class="capabilityname">{{ optional?.displayName ? optional?.displayName : optional?.name }}</span></span>
                    </button>
                    <div class="rvtTag mat-headline-2 fw-700 mt-8 mb-12 fs-10">
                      <span class="rvtTags">{{ 'SOLUTIONS.RVT_TAGS' | transloco }}</span>: {{ optional.rvtTags }}
                    </div>
                    <div *ngIf="optional.componentType" class="componentTag mat-headline-2 fw-700 h-40 mb-0 fs-10">
                      <span class="componentType fw-500 fs-10">{{ 'INSTANCE_DETAILS.COMPONENT' | transloco | uppercase }}</span>:
                      <span class="flex flex-row items-center badge fs-10 fw-700 pr-8 pl-8 ml-80">{{ optional.componentType }}</span>
                    </div>
                  </div>
                </div>
                  <div *ngIf="filteredOptionalCapabilities.length === 0" class="flex items-center mat-body-2 fs-14 fw-400 rows pl-16">
                    {{'SOLUTIONS.No_OPTIONAL_CAPABILITIES' | transloco}}
                  </div>
              </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="{{'SOLUTIONS.COMPONENTS' | transloco }}">
        <mat-divider class="neutral-2 header-divider width"></mat-divider>
        <div class="flex flex-row">
                <ng-container *ngIf="components?.length; else componentsNotAvailable">
                  <div class="settings-log w-100-percent pl-24">
                    <div class="flex flex-row justify-between product-header pt-6 pr-30 pb-6 pl-32 bg-color">
                      <div>{{'INSTANCE_DETAILS.COMPONENT' | transloco }}</div>
                      <div>{{'INSTANCE_DETAILS.CURRENT_VERSION' | transloco }}</div>
                    </div>
                    <div *ngFor="let element of componentTable | keyvalue" class="flex flex-row justify-between product-rows pt-6 pr-30 pb-6 pl-32 mt-8 mb-8">
                      <div>{{element.key}}</div>
                      <div>{{element.value}}</div>
                    </div>
                  </div>
                </ng-container>
                <ng-template #componentsNotAvailable>
                  <div class="no-data flex items-center justify-center pt-8  fw-600 fs-20  components">
                    <img src="/assets/images/instance-not-found-small.png"> <div class="ml-10">{{'SOLUTIONS.NO_COMPONENTS_AVAILABLE' | transloco}} </div>
                  </div>
                </ng-template>
        </div>
      </mat-tab>
      <mat-tab label="{{'SOLUTIONS.RVT_PACK' | transloco }}">
        <mat-divider class="neutral-2 header-divider width"></mat-divider>
        <div class="flex flex-row cards-section pt-32">
          <div class="flex flex-col">
            <div class="capability-card">
              <h2 class="mat-subtitle-2 fw-700 mt-0 mb-0 p-16">{{'SOLUTIONS.EF_TEST_LOCATION' | transloco}}</h2>
                <div *ngIf="data?.efTestPack?.length" class="flex items-center mat-body-2 fs-16 rows pl-16 pr-16">
                  1. {{data?.efTestPack}}
                </div>
                <div *ngIf="!data?.efTestPack?.length" class="flex items-center mat-body-2 fs-14 fw-400 rows pl-16">
                  {{'SOLUTIONS.NO_EF_TEST_LOCATION' | transloco}}
                </div>
            </div>
            <div class="capability-card mt-24">
            <h2 class="mat-subtitle-2 fw-700 mt-0 mb-0 p-16">{{'SOLUTIONS.RVT_PACKS' | transloco}}</h2>
              <div *ngFor="let rvtPack of data?.rvtPacks; let i = index" class="flex items-center mat-body-2 fs-16 rows pl-16 pr-16">
                {{i + 1}}. {{rvtPack}}
              </div>
              <div *ngIf="!data?.rvtPacks?.length" class="flex items-center mat-body-2 fs-14 fw-400 rows pl-16">
                {{'SOLUTIONS.NO_RVT_PACKS' | transloco}}
              </div>
            </div>
            
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <mat-card *ngIf="isLoading" class="flex spinner-container spinner m-24">
    <mat-spinner diameter="24"
      color="primary"
      mode="indeterminate">
    </mat-spinner>
  </mat-card>
</div>
